import { Autocomplete, Stack, TextField } from '@mui/material';

import useTranslate from 'hooks/useTranslate';

const fieldSx = { width: { xs: '100%', sm: 240 }, maxWidth: '100%' };

interface AdminPanelFiltersProps {
    companies: string[];
    selectedCompany: string;
    onCompanyChange: (company: string) => void;
    search: string;
    onSearchChange: (value: string) => void;
}

export function AdminPanelFilters({
    companies,
    selectedCompany,
    onCompanyChange,
    search,
    onSearchChange,
}: AdminPanelFiltersProps) {
    const { translate } = useTranslate();
    const allCompanies = translate('allCompanies');
    const options = [allCompanies, ...companies];

    return (
        <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={1.5}
            sx={{ alignItems: 'flex-start' }}
        >
            <Autocomplete
                size="small"
                options={options}
                value={selectedCompany || allCompanies}
                onChange={(_, next) => onCompanyChange(!next || next === allCompanies ? '' : next)}
                disableClearable
                sx={fieldSx}
                renderInput={(params) => <TextField {...params} label={translate('company')} />}
            />
            <TextField
                size="small"
                label={translate('search')}
                placeholder={translate('nameOrEmail')}
                value={search}
                onChange={(event) => onSearchChange(event.target.value)}
                sx={fieldSx}
            />
        </Stack>
    );
}

export default AdminPanelFilters;
